module.exports = __webpack_public_path__ + "img/inbox.605d4b34.svg";